import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";

export enum TaxableBenefits {
  CHILDBIRTH_ALLOWANCE = "Childbirth Allowance",
  EDUCATION_FOR_FAMILY = "Education for Family",
  FUNERAL_ALLOWANCE = "Funeral Allowance",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  MEAL_ALLOWANCE = "Meal Allowance",
  MEDICAL_INSURANCE = "Medical Insurance",
  NON_CASH_GIFT_AND_AWARDS = "Non-Cash Gifts & Awards",
  PHONE_ALLOWANCE = "Phone Allowance",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK = "Remote Work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.CHILDBIRTH_ALLOWANCE]: {
    text: "One-time payment per child an tax-exempt up to €500.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.FUNERAL_ALLOWANCE]: {
    text: "Tax-exempt up to €500 in the event of the death of the employee or a close relative.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.MEDICAL_INSURANCE]: {
    text: "Tax-exempt up to €700 per year.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.NON_CASH_GIFT_AND_AWARDS]: {
    text: "Tax-exempt up to €100 per year.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.REMOTE_WORK]: {
    text: "Tax-exempt up to €30 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
